import { APIError } from "graphql-hooks";

export const getErrorStatusCode = (error: APIError): number | undefined => {
  const { httpError } = error;

  return httpError ? httpError.status : undefined;
};
